// Currency formatting utility for Canadian French format
// Format: 100,00$ (comma as decimal separator, $ after amount)

export const formatCAD = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '0,00$';
  }
  
  const num = parseFloat(amount);
  // Format with 2 decimal places, replace . with , and add $ at the end
  const formatted = num.toFixed(2).replace('.', ',');
  return `${formatted}$`;
};

// Format with + or - sign for transactions
export const formatCADWithSign = (amount, forceSign = false) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '0,00$';
  }
  
  const num = parseFloat(amount);
  const formatted = Math.abs(num).toFixed(2).replace('.', ',');
  
  if (num > 0) {
    return forceSign ? `+${formatted}$` : `${formatted}$`;
  } else if (num < 0) {
    return `-${formatted}$`;
  }
  return `${formatted}$`;
};

// Format for display in transactions (with +/- prefix)
export const formatTransactionAmount = (amount, isCredit) => {
  const num = Math.abs(parseFloat(amount || 0));
  const formatted = num.toFixed(2).replace('.', ',');
  return isCredit ? `+${formatted}$` : `-${formatted}$`;
};
